import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import LibraryProxy from '../proxies/LibraryProxy'

class LibraryService extends ServiceBase {
  postCreatePortfolio(params) {
    return this.getData(() => LibraryProxy.postCreatePortfolio(params))
  }

  getSearchPortfolio(params) {
    return this.getData(() => LibraryProxy.getSearchPortfolio(params))
  }

  postCopyCompany(params) {
    return this.getData(() => LibraryProxy.postCopyCompany(params))
  }
}

export default new LibraryService()
